import { render, staticRenderFns } from "./boardcreatemodal.vue.html?vue&type=template&id=595f90fd"
import script from "./boardcreatemodal.controller.ts?vue&type=script&lang=js&external"
export * from "./boardcreatemodal.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports